import React from 'react'
import SeminarActionTabs from './SeminarActions'

const SeminarActions = (props) => (
  <SeminarActionTabs {...props} />
)

export default SeminarActions



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/index.js